import { useCallback, useContext } from 'react';
import { SectionContext } from '../../../context/SectionContext';
import SizeRestrictedButton from '../SizeRestrictedButton';
import { jsx as _jsx } from "react/jsx-runtime";
const CopilotActionButton = ({
  copilotActionButton,
  inDataTable,
  size,
  use = 'tertiary',
  disabled,
  tooltip
}) => {
  const {
    isWaitingForChatResponse,
    onCopilotActionClicked
  } = useContext(SectionContext);
  const onClick = useCallback(() => {
    onCopilotActionClicked(copilotActionButton, {
      inDataTable
    });
  }, [copilotActionButton, inDataTable, onCopilotActionClicked]);
  return /*#__PURE__*/_jsx(SizeRestrictedButton, {
    disabled: isWaitingForChatResponse || !!copilotActionButton.isDisabled || disabled,
    onClick: onClick,
    size: size,
    use: use,
    truncate: true,
    tooltip: tooltip,
    children: copilotActionButton.label
  });
};
export default CopilotActionButton;